import { apiError, CREATE_USER } from ".";

export async function doAddUser(email, password, user, role) {
  try {
    const body = { email, password, user, role };
    const response = await fetch(CREATE_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  } catch (err) {
    return apiError(err.message, err.stack, "doAddUser");
  }
}
